import React, { useState, useEffect } from 'react';

/* External */
import QrReader from 'react-qr-reader';

/* Project */
import pip from '../../assets/sounds/pip.mp3';

const parseLotIdFromQr = (raw) => {
  if (!raw) return null;
  const code = String(raw).trim();

  if (/^\d+$/.test(code)) return Number(code);

  // New format: PK,l:...,p:...
  if (code.startsWith('PK,')) {
    const pakPart = code
      .split(',')
      .find((part) => part.startsWith('p:'))
      ?.split(':')[1];
    return pakPart && /^\d+$/.test(pakPart) ? Number(pakPart) : null;
  }

  // Legacy format: "id 123" or "¿id 123#"
  const match = code.match(/id\s+(\d+)/i);
  return match ? Number(match[1]) : null;
};

function QRScanner({ onScan }) {
  const [, setCameraAccessGranted] = useState(false);

  const handleError = (error) => {
    console.error({ error });
  };

  function playSuccessSound() {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const soundSource = audioContext.createBufferSource();

    // Cargar el archivo de sonido
    const request = new XMLHttpRequest();
    request.open('GET', pip, true);
    request.responseType = 'arraybuffer';

    request.onload = () => {
      audioContext.decodeAudioData(request.response, (buffer) => {
        soundSource.buffer = buffer;
        soundSource.connect(audioContext.destination);
        soundSource.start(0);
      });
    };

    request.send();
  }

  const handleScan = (data) => {
    console.log(`Resultado de scan: ${data}`);

    if (data) {
      playSuccessSound();
      onScan(data);
    }
  };

  useEffect(() => {
    // Verificar si el navegador admite la API de getUserMedia
    const isSupported =
      navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === 'function';

    if (isSupported) {
      // Solicitar permiso para acceder a la cámara
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then(() => {
          // Permiso otorgado
          setCameraAccessGranted(true);
        })
        .catch((error) => {
          // Permiso denegado
          console.error('Error al acceder a la cámara:', error);
        });
    } else {
      console.error('La API getUserMedia no es compatible con este navegador.');
    }
  }, []);

  return (
    <div>
      <QrReader delay={1000} onError={handleError} onScan={handleScan} style={{ width: '100%' }} />
    </div>
  );
}

export default QRScanner;
